var map = {
	"./3ds.svg": 72268,
	"./aac.svg": 71389,
	"./ai.svg": 35594,
	"./avi.dark.svg": 67464,
	"./avi.svg": 84126,
	"./bmp.svg": 41553,
	"./cad.svg": 23652,
	"./cdr.svg": 31709,
	"./css.svg": 34405,
	"./csv.dark.svg": 63002,
	"./csv.svg": 3000,
	"./dat.svg": 50323,
	"./default.svg": 96727,
	"./dll.svg": 76612,
	"./dmg.svg": 29756,
	"./doc.dark.svg": 89628,
	"./doc.svg": 33578,
	"./docx.dark.svg": 51976,
	"./docx.svg": 73118,
	"./eps.svg": 26118,
	"./fla.svg": 11675,
	"./flv.svg": 12324,
	"./gif.dark.svg": 3140,
	"./gif.svg": 47746,
	"./html.dark.svg": 41363,
	"./html.svg": 63199,
	"./indd.svg": 74125,
	"./iso.svg": 15839,
	"./jpg.dark.svg": 29193,
	"./jpg.svg": 10245,
	"./js.svg": 31205,
	"./json.dark.svg": 12920,
	"./json.svg": 45678,
	"./key.dark.svg": 87969,
	"./key.svg": 73837,
	"./md.dark.svg": 10495,
	"./md.svg": 87075,
	"./midi.svg": 8323,
	"./mov.dark.svg": 94320,
	"./mov.svg": 18358,
	"./mp3.svg": 35198,
	"./mp4.dark.svg": 22941,
	"./mp4.svg": 95105,
	"./mpg.svg": 33954,
	"./pdf.dark.svg": 71388,
	"./pdf.svg": 35466,
	"./php.svg": 38408,
	"./png.dark.svg": 73657,
	"./png.svg": 79413,
	"./ppt.svg": 81148,
	"./pptx.dark.svg": 7062,
	"./pptx.svg": 91596,
	"./ps.svg": 34483,
	"./psd.svg": 49301,
	"./rar.dark.svg": 17203,
	"./rar.svg": 85695,
	"./raw.svg": 41858,
	"./sql.svg": 80812,
	"./svg.dark.svg": 10092,
	"./svg.svg": 80858,
	"./tif.svg": 28073,
	"./txt.dark.svg": 78538,
	"./txt.svg": 51336,
	"./unknown.dark.svg": 21936,
	"./unknown.svg": 94473,
	"./webm.dark.svg": 62407,
	"./webm.svg": 88987,
	"./webp.dark.svg": 19768,
	"./webp.svg": 4078,
	"./wmv.svg": 32054,
	"./xls.dark.svg": 36651,
	"./xls.svg": 10215,
	"./xlsx.svg": 90493,
	"./xml.dark.svg": 21183,
	"./xml.svg": 42723,
	"./zip.dark.svg": 7793,
	"./zip.svg": 47357
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76426;